import React from 'react'

export const ModalCancelAsync = React.lazy(() => import('./modal-cancel'))
